import ModalContext from "@/contexts/ModalsContext";
import { useContext } from "react";

export const useModals = () => useContext(ModalContext);
